<div class="body">
  <div class="container mt-4">
    <div class="title-box">
      <h3 class="txtbienvenida">
        Consulta histórico de
        <span class="txtbienvenida-2">solicitudes realizadas</span>
      </h3>
    </div>
  </div>
  <div class="container mt-4">
    <form [formGroup]="consultarHistoricoForm">
      <div class="row myForm">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
          <div class="mb-3 form-label" [ngClass]="{
              err: isValidFieldConsultaMicroForm('fechaInicial')
            }">
            <label class="form-label">Fecha inicial</label
              >
              <input
                type="date"
                class="form-control"
              [ngClass]="{
                'is-invalid':
                  isValidFieldConsultaMicroForm('fechaInicial')
              }"
                formControlName="fechaInicial"
                (change)="validarFechas()"
                min="1950-01-01" max="{{fechaActual}}"
                />
                <div class="invalid-feedback">
                  La fecha incial no puede ser menor a la fecha final.
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
              <div
                class="mb-3 form-label"
            [ngClass]="{
              err: isValidFieldConsultaMicroForm('fechaFinal')
            }"
                >
                <label class="form-label"
                  >Fecha final</label
                  >
                  <input
                    type="date"
                    class="form-control"
              [ngClass]="{
                'is-invalid': isValidFieldConsultaMicroForm('fechaFinal')
              }"
                    formControlName="fechaFinal"
                    (change)="validarFechas()"
                    min="obtenerValorCampo('fechaInicial')"
                    required
                    />
                  </div>
                </div>
                <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                <div class="mb-3">
                  <label for="" class="form-label">Estado de la solicitud</label>
                  <select class="form-control selectpicker" data-size="3" data-live-search="true" formControlName="idEstadoSolicitud">
                    <option [value]="null">Seleccione...</option>
                    <option *ngFor="let estado of estados" >
                      {{ estado.nombre }}
                    </option>
                  </select>
                </div>
              </div> -->
            </div>
            <div class="row justify-content-md-center mt-2 g-3">
              <div class="col-12 col-md-2 container-btn">
          <button class="btn btn-primary" style="width: 180px;" type="submit" [ngClass]="{
                    'hvr-shrink': consultarHistoricoForm.valid && cualquierCampoIngresado()}" (click)="consultarHistorico()">
                  Consultar
                </button>
              </div>
              <div class="col-12 col-md-2 container-btn">
                <button class="btn btn-primary hvr-shrink" type="button" style="width: 180px;" (click)="limpiarFormulario()">
                  Limpiar filtros
                </button>
              </div>
              <div class="col-12 col-md-2 container-btn">
                <button type="button" class="btn btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">
                  Volver
                </button>
              </div>
            </div>
            @if (consulta) {
              <div class="row justify-content-md-center mt-2 g-3">
                <div class="col-12 col-md-3 container-btn">
                  <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button" (click)="generarReporte(true)">
                    Exportar a Excel
                  </button>
                </div>
                <div class="col-12 col-md-3 container-btn">
                  <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button" (click)="generarReporte(false)">
                    Exportar a txt
                  </button>
                </div>
              </div>
            }
          </form>
          @if (this.historico.length > 0 && consulta) {
            <div class="row mt-4 pr-3 pl-3">
              <div class="table-responsive">
                <table class="table table-striped table-borderless rounded">
                  <thead class="table_head">
                    <tr>
                      <th scope="col" class="no-styles table-header">
                        Razón social
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Número solicitud
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Estado solicitud
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Tipo de documento
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Número de documento
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Monto ofertado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Tasa
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Plazo
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Gestión realizada con el microempresario
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Departamento
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Ciudad
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Fecha envío oferta
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Fecha aceptación o rechazo
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Observación negación
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Acceso a crédito formal con anterioridad
                      </th>
                      <th scope="col" class="no-styles table-header">Ver detalles</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (hist of historico; track hist) {
                      <tr>
                        <td scope="row">
                          {{ hist.razonSocialEmpresario }}
                        </td>
                        <td>
                          {{ hist.idSolicitudCredito }}
                        </td>
                        <td>
                          {{ hist.estado }}
                        </td>
                        <td>
                          {{ hist.tipoDocumentoEmpresario }}
                        </td>
                        <td>
                          {{ hist.numeroDocumentoEmpresario}}
                        </td>  <td>
                        {{ hist.monto | currency: "USD" : "symbol" : "1.0-0"}}
                      </td>
                      <td>
                        {{ hist.tasa}}
                      </td>
                      <td>
                        {{ hist.plazo}}
                      </td>
                      @if (hist.avanceFormalizacion!= undefined) {
                        <div>
                          @for (elemento of hist.avanceFormalizacion.avances; track elemento) {
                            <div>
                              <td >
                                {{elemento.fechaActualizacion|date: 'dd/MM/yyyy hh:mm a' : 'UTC'}}
                              </td>
                              <td>
                                {{separarString(elemento.nombreUsuario)}}
                              </td>
                              <td>
                                <textarea class="boxTexto" style="height: 150px; width: 300px;"
                                [disabled]="true">{{elemento.observacion}}</textarea>
                              </td>
                            </div>
                          }
                        </div>
                      }
                      @if (hist.avanceFormalizacion== undefined) {
                        <div>
                          {{''}}
                        </div>
                      }
                      <td>
                        {{ hist.departamentoEmpresario}}
                      </td>
                      <td>
                        {{ hist.ciudadEmpresario}}
                      </td>
                      <td>{{ hist.fechaPropuesta | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                      <td>{{ hist.fechaActualizacion | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                      <td>{{ hist.observacionesNegacion }}</td>
                      <td>
                        {{hist.creditoAnterior}}
                      </td>
                      <td>
                        <a (click)="verDetalles(hist.idSolicitudCredito)">
                          <i class="fas fa-eye text-light"></i>
                        </a>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (this.historico.length > 0 && consulta) {
          <app-pagination (event)="selectPage($event)" [paginaActual]="paginaActual"
          [totalPaginas]="totalPaginas"></app-pagination>
        }
        <!-- Modal -->
        <div class="modal fade text-center" style="color: black;" id="mensajeModal" tabindex="-1" aria-labelledby="mensajeModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body justify-content-md-center">
                <div class="row">
                  <div class="col-12 col-sm-12 me-3 ms-3">
                    <h2>No se encontraron operaciones con los criterios seleccionados</h2>
                  </div>
                </div>
              </div>
              <div class="modal-footer justify-content-md-center">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a id="downloadFile" style="display: none"></a>
      <div class="footer-body"></div>
    </div>
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>


